jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
         var after_pay_unit = $('square-placement');
        //var selected_variant_price = parseInt($('.money').text());
        //if (selected_variant_price != 'NaN') {
        let AUDollar = new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD',
        });
        //after_pay_unit.data('amount',variant.price);
        
        $('square-placement .afterpay-main-text strong').text(AUDollar.format(evt.currentVariant.price/100/4));
        if (evt.currentVariant.price >= 200000) {
          after_pay_unit.css({ visibility: "hidden"}); 
        }else{
          after_pay_unit.css({ visibility: "visible"});
        }
        console.log('%c After pay value set to %s from %s', 'background: #222; color: #bada55', $('square-placement .afterpay-main-text strong').text(), evt.currentVariant.price);
        //}
	   });

});